import React from 'react';
import { Chip, Tooltip, Typography } from '@mui/material';

// The nightly analyzer auto-adds suggestions at >= 0.8; a label still listed with a
// suggestion was below that, or the AI gave different answers (a conflict).
export const AUTO_ADD_THRESHOLD = 0.8;

// One AI suggestion for an unmapped label: value · confidence, coloured by what the
// analyzer would do with it. Shared by the unmapped-categories and unmapped-patterns queues.
export default function SuggestionChip({ row }) {
  if (!row.suggested_normalized_value) {
    return <Typography variant="body2" color="text.secondary">-</Typography>;
  }
  const conflict = row.review_status === 'conflict_multiple_suggestions';
  const pct = (c) => `${Math.round((c || 0) * 100)}%`;
  // A conflict = the AI gave different answers; show them all, best first, so the admin can
  // see what it disagreed between (and pick one in the Map dialog).
  const answers = (row.suggestions || []).length > 1 ? row.suggestions : [{ value: row.suggested_normalized_value, confidence: row.confidence }];
  const label = answers.map(a => `${a.value} ${pct(a.confidence)}`).join(' / ');
  return (
    <Tooltip
      title={
        conflict
          ? 'The AI gave different answers for this label — pick one with Map'
          : row.review_status === 'awaiting_analysis'
            ? `The AI's latest answer; the nightly analyzer maps it automatically tonight if it is >= 80% (family: ${row.suggested_family || 'unknown'})`
            : `Family: ${row.suggested_family || 'unknown'}`
      }
    >
      <Chip
        label={conflict ? `${label} · conflict` : label}
        size="small"
        variant="outlined"
        color={conflict ? 'warning' : row.confidence >= AUTO_ADD_THRESHOLD ? 'success' : 'default'}
      />
    </Tooltip>
  );
}
